import type { ReactNode } from 'react';

export const AdministrationTabsWrapper: FC<{ children: ReactNode }> = ({ children }) => (
  <div className='flex w-full flex-col gap-3 p-5'>{children}</div>
);
